import request from '@/utils/request'

export function fetchList(data) {
  return request({
    url: '/lockerSize/List',
    method: 'post',
    data,
  })
}

export function getItem(id) {
  return request({
    url: '/lockerSize/Get',
    method: 'post',
    data: { id },
  })
}

export function createItem(data) {
  // console.log('createItem', data)
  return request({
    url: '/lockerSize/Create',
    method: 'post',
    data,
  })
}

export function updateItem(data) {
  // console.log('updateItem', data)
  return request({
    url: '/lockerSize/Update',
    method: 'post',
    data,
  })
}

export function deleteItem(data) {
  return request({
    url: '/lockerSize/Delete',
    method: 'delete',
    data,
  })
}
